import { createAsyncThunk } from '@reduxjs/toolkit';
import * as daAPI from './declaracoesAduaneirasAPI';
import { setErrorFeedback, setSuccessFeedback } from '../feedback/feedbackSlice';

const fetchAllDAImportacaoByFilterAsync = createAsyncThunk(
  'declaracoesAduaneiras/fetchAllDAImportacaoByFilter',
  async (params) => {
    const { data } = await daAPI.fetchDAImportacaoByFilter(params);
    return { data };
  }
);
const salvarDataVencimentoDaAsync = createAsyncThunk(
  'declaracoesAduaneiras/salvarDataVencimentoDa',
  async ({ id, dataVencimento }, { dispatch, rejectWithValue }) => {
    try {
      const res = await daAPI.updateFollowUpDataVencimentoDa(id, dataVencimento);

      const message =
        (res && typeof res === 'string' && res) ||
        (res && typeof res?.data === 'string' && res.data) ||
        'Data de vencimento DA atualizada com sucesso.';

      dispatch(setSuccessFeedback({ message }));

      return { id, dataVencimento };
    } catch (err) {
      const backendMsg =
        err?.response?.data ||
        err?.message ||
        'Erro ao atualizar a data de vencimento DA.';

      dispatch(setErrorFeedback({ message: backendMsg }));

      return rejectWithValue(backendMsg);
    }
  }
);

const fetchBaixaDAMercadoriasByFilterAsync = createAsyncThunk(
  'declaracoesAduaneiras/fetchBaixaDAMercadoriasByFilter',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await daAPI.fetchBaixaDAMercadoriasByFilter(params);
      return { data };
    } catch (err) {
      return rejectWithValue(err?.response?.data || err?.message || 'Erro ao carregar mercadorias.');
    }
  }
);

const fetchFollowupsDestinoComDiAsync = createAsyncThunk(
  'declaracoesAduaneiras/fetchFollowupsDestinoComDi',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await daAPI.fetchFollowupsDestinoComDi(params);
      return { data };
    } catch (err) {
      return rejectWithValue(err?.response?.data || err?.message || 'Erro ao carregar followups destino.');
    }
  }
);

const transferirItensDaAsync = createAsyncThunk(
  'declaracoesAduaneiras/transferirItensDa',
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const res = await daAPI.postTransferirItensDa(payload);

      const message =
        (res && typeof res === 'string' && res) ||
        (res && typeof res?.data === 'string' && res.data) ||
        res?.data?.message ||
        'Transferência realizada com sucesso.';

      dispatch(setSuccessFeedback({ message }));
      return { result: res?.data || res };
    } catch (err) {
      const backendMsg =
        err?.response?.data ||
        err?.message ||
        'Erro ao realizar a transferência.';

      dispatch(setErrorFeedback({ message: backendMsg }));
      return rejectWithValue(backendMsg);
    }
  }
);

const salvarQtdeBaixaDaAsync = createAsyncThunk(
  'declaracoesAduaneiras/salvarQtdeBaixaDa',
  async ({ mercadoriaId, quantidade }, { dispatch, rejectWithValue }) => {
    try {
      const res = await daAPI.updateMercadoriaQtdeBaixaDa(mercadoriaId, quantidade);

      const message =
        (res && typeof res === 'string' && res) ||
        (res && typeof res?.data === 'string' && res.data) ||
        'Quantidade a baixar atualizada com sucesso.';

      dispatch(setSuccessFeedback({ message }));
      return { mercadoriaId, quantidade };
    } catch (err) {
      const backendMsg =
        err?.response?.data ||
        err?.message ||
        'Erro ao atualizar a quantidade a baixar.';
      dispatch(setErrorFeedback({ message: backendMsg }));
      return rejectWithValue(backendMsg);
    }
  }
);

const fetchEstornoDAMercadoriasByFilterAsync = createAsyncThunk(
  'declaracoesAduaneiras/fetchEstornoDAMercadoriasByFilter',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await daAPI.fetchEstornoDAMercadoriasByFilter(params);
      return { data };
    } catch (err) {
      return rejectWithValue(err?.response?.data || err?.message || 'Erro ao carregar mercadorias para estorno.');
    }
  }
);

const estornarItensDaAsync = createAsyncThunk(
  'declaracoesAduaneiras/estornarItensDa',
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const res = await daAPI.putEstornarItensDa(payload);
      const message =
        (res && typeof res === 'string' && res) ||
        (res && typeof res?.data === 'string' && res.data) ||
        res?.data?.message ||
        'Estorno realizado com sucesso.';
      dispatch(setSuccessFeedback({ message }));
      return { result: res?.data || res };
    } catch (err) {
      const backendMsg = err?.response?.data || err?.message || 'Erro ao realizar o estorno.';
      dispatch(setErrorFeedback({ message: backendMsg }));
      return rejectWithValue(backendMsg);
    }
  }
);

const estornarQuantidadeDaAsync = createAsyncThunk(
  'declaracoesAduaneiras/estornarQuantidadeDa',
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const res = await daAPI.putEstornarQuantidadeDa(payload);
      const message =
        (res && typeof res === 'string' && res) ||
        (res && typeof res?.data === 'string' && res.data) ||
        res?.data?.message ||
        'Estorno realizado com sucesso.';
      dispatch(setSuccessFeedback({ message }));
      return { result: res?.data || res };
    } catch (err) {
      const backendMsg = err?.response?.data || err?.message || 'Erro ao estornar.';
      dispatch(setErrorFeedback({ message: backendMsg }));
      return rejectWithValue(backendMsg);
    }
  }
);

export {
  fetchAllDAImportacaoByFilterAsync,
  salvarDataVencimentoDaAsync,
  salvarQtdeBaixaDaAsync,
  fetchBaixaDAMercadoriasByFilterAsync,
  fetchFollowupsDestinoComDiAsync,
  transferirItensDaAsync,
  fetchEstornoDAMercadoriasByFilterAsync,
  estornarItensDaAsync,
  estornarQuantidadeDaAsync,
};
